<template>
    <div class="row">
        <div class="col-6 form-group">
            <label for="firstName">First Name</label>
            <input
                id="firstName"
                v-model="teacher.firstName"
                class="form-control"
                :class="{ 'is-invalid': hasError('firstName') }"
                type="text"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('firstName') }}
            </div>
        </div>
        <div class="col-6 form-group">
            <label for="lastName">Last Name</label>
            <input
                id="lastName"
                v-model="teacher.lastName"
                class="form-control"
                :class="{ 'is-invalid': hasError('lastName') }"
                type="text"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('lastName') }}
            </div>
        </div>
        <div class="col-12 form-group">
            <label for="bio">Bio</label>

            <textarea
                id="bio"
                v-model="teacher.bio"
                class="form-control rtl"
                :class="{ 'is-invalid': hasError('bio') }"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('bio') }}
            </div>
        </div>

        <div class="col-12 form-group">
            <label for="image">Image</label>

            <media-chooser
                id="image"
                v-model="teacher.imageId"
                type="image"
                id-only
                :error-border="!!hasError('imageId')"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            teacher: {}
        };
    },

    watch: {
        teacher() {
            this.$emit('input', this.teacher);
        }
    },

    created() {
        this.teacher = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation.teacher[key]?.$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.teacher,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
